import { useEffect } from "react";

const SKEY = "alphaapeing_sound";
export const isSoundOn = () => localStorage.getItem(SKEY) !== "off";
export const setSoundOn = (on) => localStorage.setItem(SKEY, on ? "on" : "off");

let audioCtx;
export const playChime = () => {
  if (!isSoundOn()) return;
  try {
    audioCtx = audioCtx || new (window.AudioContext || window.webkitAudioContext)();
    if (audioCtx.state === "suspended") audioCtx.resume();
    const now = audioCtx.currentTime;
    // bright ascending "cha-ching" chime
    [[880, 0], [1174.7, 0.10], [1567.98, 0.20]].forEach(([f, dt]) => {
      const o = audioCtx.createOscillator();
      const g = audioCtx.createGain();
      o.type = "triangle";
      o.frequency.value = f;
      const t = now + dt;
      g.gain.setValueAtTime(0, t);
      g.gain.linearRampToValueAtTime(0.22, t + 0.015);
      g.gain.exponentialRampToValueAtTime(0.001, t + 0.45);
      o.connect(g);
      g.connect(audioCtx.destination);
      o.start(t);
      o.stop(t + 0.47);
    });
  } catch {
    /* audio unsupported / blocked */
  }
};

const chimed = new Set();
let seeded = false;

// Plays the chime when a NEW alpha mint appears in the list (dedup across the session).
export const useAlphaChime = (mints) => {
  const key = (mints || []).join(",");
  useEffect(() => {
    const list = mints || [];
    if (!seeded) {
      list.forEach((m) => chimed.add(m));
      if (list.length) seeded = true;
      return;
    }
    const fresh = list.filter((m) => !chimed.has(m));
    if (fresh.length) {
      fresh.forEach((m) => chimed.add(m));
      playChime();
    }
  }, [key]); // eslint-disable-line react-hooks/exhaustive-deps
};
